import React, { Suspense, useCallback, useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Loader from 'components/ui/loader';
import GameHeader from '../gameHeader';
import Header from '../header';
import { FeedsApi, useFixturesQuery, useGetMixApiQuery } from 'api/feeds';
import config from 'utils/config';
import TokenAcquisition from '../login/tokenAquisition';
import { setDailyMixApiData, setGameFixtures } from 'store/slice/createTeamSlice';
import { useDispatch, useSelector } from 'react-redux';
import { deleteAllCookies, getCookie, isWebView, setCookie } from 'utils/commonFunctions';
import { useWebviewLoginMutation } from 'api';
import { setUserLoggedIn } from 'store/slice/loginSlice';
import { setToastMessage, closeToast } from 'store/slice/toastMessageSlice';
import ToastMessage from '../toastMessage';

const AppLayout = () => {
  const [webviewLogin, { isWebviewLoginLoading, isWebviewLoginError }] = useWebviewLoginMutation();
  const [shouldRenderOutlet, setShouldRenderOutlet] = useState(isWebView() ? false : true);
  const [goAhead, setGoAhead] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const toastState = useSelector((state) => state.toastMessage.toastMessageState);

  const [fixApiCall, { data: fixturedata, error: fixtureError, isLoading: fixtureLoading }] =
    FeedsApi.endpoints.fixtures.useLazyQuery();
  const [
    translationsData,
    { data: transData, error: errorGamedays, isLoading: isLoadingGamedays }
  ] = FeedsApi.endpoints.trans.useLazyQuery();

  useEffect(() => {
    translationsData().then((res) => {
      if (res?.isSuccess) {
        setGoAhead(true);
      }
    });
  }, []);

  useEffect(() => {
    if (transData && transData.Data && transData.Data.Value) {
      window['translations'] = transData.Data.Value;
    }
  }, [transData]);

  const {
    data: dailyMix,
    error: dailyMixError,
    isLoading: dailyMixIsLoading,
    refetch: refetchDailyMixApi
  } = useGetMixApiQuery({
    refetchOnMountOrArgChange: true
  });

  useEffect(() => {
    const intervalId = setInterval(() => {
      refetchDailyMixApi();
    }, 10000);

    return () => clearInterval(intervalId);
  }, [refetchDailyMixApi]);

  useEffect(() => {
    if (dailyMix) {
      dispatch(setDailyMixApiData(dailyMix));
    }
  }, [dailyMix]);

  useEffect(() => {
    if (dailyMix?.Data?.Value?.version_master) {
      fixApiCall().then((res) => {
        if (res.isSuccess) {
          dispatch(setGameFixtures(res?.data?.Data?.Value));
        }
      });
    }
  }, [dailyMix?.Data?.Value?.version_master]);

  if (process.env.NODE_ENV == 'development') {
    window.standaloneTopPicks = {
      isLoggedIn: () => true,
      logIn: () => {},
      getAccessToken: () => {
        return Promise.resolve(
          'eyJhbGciOiJSUzI1NiIsImtpZCI6Imlia2V5MTIzNDUiLCJ0eXAiOiJKV1QifQ.eyJhdWQiOiJkZXYtc2NhbGUtZnJhbmtmdXJ0LWF3cyIsImlzcyI6Imh0dHBzOi8vZGVsdGF0cmUuY29tL2lzc3VlciIsImV4cCI6MTczOTc5NDY1NCwiaWF0IjoxNzM5NzkyODU0LCJuYmYiOjE3Mzk3OTI4NTQsInN1YiI6Ijk3MDU4OGQ4LTVmOTAtNDRlNi1iYjZmLWIxYzM5YmQwMmIxYSIsInByb2ZpbGVfaWQiOiI5NzA1ODhkOC01ZjkwLTQ0ZTYtYmI2Zi1iMWMzOWJkMDJiMWEiLCJpZHBfc3ViIjoiNGE0OTBkNTItYzk2Yy00MmVmLTgxZjktMDE4YTE4YTZmZDQ2IiwidGVuYW50X2lkIjoiaWNjZGV2IiwianRpIjoiZmNlODQ5NzQtY2Y2MC00ODZiLWJhNmYtODcxMmViZjhjNjc1Iiwic2lkIjoiNjJlMjQyNzUtNjJmMy00OTQ5LThmYjUtZDM1ODNhMDM5OTI1IiwiZGV2aWNlX2lkIjoiNDcxODhmYmQtZTg3MC00OWUzLTg0MTEtZGM3MjA3YjZjZGJmIiwiZGV2aWNlX3R5cGUiOiJ3ZWJfYnJvd3NlciIsInJvbGUiOiJ1c2VyIiwic2NvcGUiOiJjYXRhbG9ndWUucmVhZCIsInR5cCI6ImFjY2VzcyIsImF6cCI6IjdkMThjYjY2LTViYWYtNDk3OS04NWMzLTlhNmNjMzdlNjIyZSIsImlkcF9iYWciOnsicHJvdmlkZXIiOiJBREIyQyIsInRmcCI6IkIyQ18xQV9TSUdOSU5TSUdOVVAifX0.o9g1Xexs2PYna9M0f1d2A3uYaAcWcqSsvKiSAViI1vQP2uzogE0IiobODMQHs5mLtaRS9tcu-ClHPFGpntvt34xQLJx8C9VX3OsV68dU0SYsk2McdL4-egG4sp2i90X6tC5YZrletnh0gaUsPQdYR3Ma0i2fD2_ySpLISPV8gMOg63iLQ4bDiJM7CA4fYV_xk8C-rnu8AX1Fzm0UVAQvllGqQFr_0bSQpjzSjTtEQZHoQXi7qoLDUoNx13j6zYI6gMWJ3gOm1MSQ2mVINnjxq7fXe4nezmaUWuFfRBP3w5x3U7SkQ4dhqnecqSg7Dhh58uKZy2U0YqWeQtMMqjdmkw'
        );
      }
    };
  }

  const performLogin = useCallback(async () => {
    if (isWebView()) {
      const accessToken = await window?.standaloneTopPicks?.getAccessToken();
      const webviewLoginResponse = await webviewLogin({ token: accessToken });
      if (webviewLoginResponse?.data?.Meta?.RetVal === 1) {
        setCookie('icc-game-cookie', JSON.stringify(webviewLoginResponse?.data?.Data?.Value));
        dispatch(setUserLoggedIn(true));
        setShouldRenderOutlet(true);
        const preLoginRoute = localStorage.getItem('preLoginRoute');
        if (preLoginRoute) {
          navigate(preLoginRoute);
        }
      }
    }
  }, [webviewLogin]);

  useEffect(() => {
    setTimeout(() => {
      setShouldRenderOutlet(true);
    }, 3000);
  }, []);

  useEffect(() => {
    if (isWebView()) {
      if (window?.standaloneTopPicks && shouldRenderOutlet) {
        if (window?.standaloneTopPicks?.isLoggedIn && !window?.standaloneTopPicks?.isLoggedIn()) {
          const gameCookie = getCookie('icc-game-cookie');
          if (gameCookie) {
            deleteAllCookies(false);
          }
        } else {
          if (window?.standaloneTopPicks?.isLoggedIn && window?.standaloneTopPicks?.isLoggedIn()) {
            performLogin();
          }
        }
      } else {
        console.error('standaloneTopPicks object not exposed in window');
      }
    }
  }, [shouldRenderOutlet]);

  if (isWebviewLoginLoading || dailyMixIsLoading) {
    return <Loader />;
  }
  if (goAhead) {
    return (
      <div>
        <Suspense fallback={<Loader />}>
          {!config.isMobile() && <div className='si-brandingSticky'></div>}
          {!isWebView() && <TokenAcquisition />}
          {!isWebView() && <GameHeader />}
          <Header />
          <Outlet />
          {toastState.open && (
            <ToastMessage {...toastState} handleClose={() => dispatch(closeToast())} />
          )}
        </Suspense>
      </div>
    );
  } else return <Loader />;
};

export default AppLayout;
